import { generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

// Invisible, server-only redirect card. The live-site behavior runs in the web app
// (YinzCam.Core.MatchSectionRedirect server hook): given a gameId, it resolves the match's
// home/away/competition and redirects the page into the correct team site section.
// This spec exists so authors can place and configure the card in the CMS.
//
// Data binding: bind a `YinzCamAppServerGameBox` source (e.g. `/Game/Box?id={{gameId}}`) and
// set the card transform to `match-redirect`, which resolves gameId/homeTeamId/awayTeamId/compId.
export const specification = new BaseAtomSpec(
  "Match Section Redirect",
  generateRootObjectSchema({
    container: generateAtomContainerSchema(),
    gameId: generateStringSchema(
      "Game ID",
      "Resolved from the bound game-box source via the `match-redirect` transform."
    ),
    homeTeamId: generateStringSchema(
      "Home Team ID",
      "Resolved from the bound game-box source via the `match-redirect` transform."
    ),
    awayTeamId: generateStringSchema(
      "Away Team ID",
      "Resolved from the bound game-box source via the `match-redirect` transform."
    ),
    compId: generateStringSchema(
      "Competition ID",
      "Resolved from the bound game-box source via the `match-redirect` transform."
    ),
    gameIdParam: generateStringSchema(
      "Game ID Query Param",
      "Query parameter that gates the redirect (default: gameId).",
      { defaultValue: "gameId" }
    ),
    targetSlug: generateStringSchema(
      "Target Slug",
      "Page slug under the resolved section (default: current page slug, including slug1 when nested).",
      { defaultValue: "" }
    ),
  })
);
